module.exports = " <footer class=footer _v-ab0d84f4=\"\"> <ul _v-ab0d84f4=\"\"> <li _v-ab0d84f4=\"\"><a href=http://2015.phpconf.tw/ _v-ab0d84f4=\"\">2015</a></li> <li _v-ab0d84f4=\"\"><a href=http://2014.phpconf.tw/ _v-ab0d84f4=\"\">2014</a></li> <li _v-ab0d84f4=\"\"><a href=http://2013.phpconf.tw/ _v-ab0d84f4=\"\">2013</a></li> <li _v-ab0d84f4=\"\"><a href=http://2012.phpconf.tw/ _v-ab0d84f4=\"\">2012</a></li> <li _v-ab0d84f4=\"\"><a href=http://2011.phpconf.tw/ _v-ab0d84f4=\"\">2011</a></li> </ul> 2016 © PHPConf Taiwan </footer> ";


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-ab0d84f4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
 ** module id = 69
 ** module chunks = 1
 **/